import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Hero.module.css';
import Button from '../UI/Button';
// Import your hero image (adjust the path as needed)
import heroImage from '../../assets/Images/hero-image.jpg';

const Hero = () => {
    return (
        <section className={styles.hero}>
            <div className={styles.heroContent}>
                <div className={styles.heroText}>
                    <h1 className={styles.heroTitle}>
                        Transform Your Business with <span className={styles.highlight}>Digital Excellence</span>
                    </h1>
                    <p className={styles.heroSubtitle}>
                        We provide cutting-edge solutions that drive growth, enhance efficiency, 
                        and create exceptional digital experiences for your customers.
                    </p>
                    <div className={styles.heroCtas}>
                        <Button
                        as={Link}
                        to="/services"
                        variant="primary"
                        size="large"
                        className={styles.ctaPrimary}
                        >
                        Explore Services
                        </Button>
                        <Button
                        as={Link}
                        to="/about"
                        variant="secondary"
                        size="large"
                        className={styles.ctaSecondary}
                        >
                        Learn More
                        </Button>
                    </div>
                </div>
                <div className={styles.heroVisual}>
                    <img 
                        src={heroImage} 
                        alt="Digital transformation and business growth" 
                        className={styles.heroImage}
                    />
                </div>
            </div>
        </section>
    );
};

export default Hero;